import { Link } from 'react-router-dom';
import HeroShader from '../pages/HeroShader';
import arrowright from '../assets/icons/button-arrow-right.svg';

const CTA = () => {
  return (
    <section className="relative h-[500px] md:min-h-screen bg-[#010003] text-white flex items-center justify-center px-4 overflow-visible">
      {/* Gradient transition from previous section */}
      {/*<div className="absolute top-0 left-0 w-full h-[100px] z-10 pointer-events-none"
           style={{
             background: 'linear-gradient(to bottom, #010003 0%, #020405 70%, transparent 100%)',
           }}
      />*/}
      
      {/* HeroShader background */}
      <div className="absolute inset-0 w-full h-full mix-blend-lighten overflow-visible mt-[100px]">
        <div className="absolute inset-0 w-full h-full" style={{ transform: 'scaleX(-1)' }}>
          <HeroShader />
        </div>
      </div>
      
      <div className="relative z-10 text-center">
        <h2 className="font-['CalSans'] font-bold text-4xl md:text-[68px] tracking-[-0.02em] leading-[1.5] bg-gradient-to-r from-[#d5d8f6] from-30% via-[#d5d8f6] via-50% to-white to-90% bg-clip-text text-transparent text-center mb-12 max-w-[1000px] mx-auto">
          The best AI systems< br />are build side by side.
        </h2>
        
        <div className="flex flex-row justify-center gap-6">
          <a 
            href="https://audit.blcks.at" 
            target="_blank"
            rel="noopener noreferrer"
            className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-16 px-[18px] bg-white text-black font-medium w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)] min-w-[160px] flex-shrink-0"
          >
            <span 
              className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
              aria-hidden="true"
            />
            <span className="relative z-10">KI-Online Audit</span>
            <img 
              src={arrowright} 
              alt="" 
              className="relative z-10 ml-1.5 h-5 w-5 shrink-0" 
              width={16} 
              height={16} 
            />
          </a>
          
          <Link 
            to="/contact"
            className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-16 px-[18px] bg-white text-black font-medium w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)] min-w-[160px] flex-shrink-0"
          >
            <span 
              className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
              aria-hidden="true"
            />
            <span className="relative z-10">Kontaktiere uns</span>
            <img 
              src={arrowright} 
              alt="" 
              className="relative z-10 ml-1.5 h-5 w-5 shrink-0" 
              width={16} 
              height={16} 
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTA;
